export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-flickr-6f817f2d01331a82d386ab8239f6054a.svg";